var map = {
	"./blaze.jpg": "fQSv",
	"./characa.jpg": "a4vi",
	"./cotsukuri.jpg": "WkKQ",
	"./icon.png": "fqxG",
	"./motibell.jpg": "qRgq",
	"./omoitsuki.jpg": "8iv9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0